import {useCallback} from "react";
import {call} from "redux-saga/effects";

import {useSagaCallback} from "../store/sagas";
import {apiPost, useGetRequestData} from './client';

export const useFlairs = (feedbackCh, community, type) =>
    useGetRequestData(feedbackCh, `/api/v2/community/${type}_flairs.json?community=${community}`)?.flairs;

export const useSetFlairs = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (community, type, flairs) {
        yield call(apiPost, `/api/v2/community/set_flairs.json`, {
            community,
            type,
            flairs
        });
    }, []));
};

export const useSetPostFlair = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id, flair_text, flair_class) {
        yield call(apiPost, `/api/v2/post/set_flair`, {
            id,
            flair_text,
            flair_class
        });
    }, []));
};

export const useDeletePostFlair = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id) {
        yield call(apiPost, `/api/v2/post/delete_flair`, {
            id
        });
    }, []));
};

export const useSetUserFlair = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (username, community, flair_text, flair_class) {
        yield call(apiPost, `/api/v2/community/set_flair`, {
            author: username,
            community,
            flair_text,
            flair_class
        });
    }, []));
};

export const useDeleteUserFlair = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (username, community) {
        yield call(apiPost, `/api/v2/community/delete_flair`, {
            author: username,
            community
        });
    }, []));
};